<template>
  <div>

    <!-- DEFAULT TOGGLE -->
    <div class="mb-4 bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-4 pl-3 pr-3 mb-4">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Default Toggle</h5>
        <p class="text-gray-500">Just a basic toggle</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : view === 'preview'}" @click="view = 'preview'">Preview</b-button>
        <b-button :class="{'active' : view === 'code'}"  @click="view = 'code'">Code</b-button>
      </ButtonGroup>
    </div>

    <CodePreviewViewer :viewMode="view" :codeSample="require('@/components/local/Toggle/toggle.js').default">
      <template v-slot:preview>
        <div class="bg-gray-100 p-3">
          <p>Active</p>
          <Toggle v-model="value"/>
          <div class="mt-2">Value: <strong>{{ value }}</strong></div>

          <br><br>

          <p>Disabled</p>
          <Toggle v-model="valueNo" disabled/><br>
          <Toggle v-model="valueYes" disabled/>
        </div>
      </template>
    </CodePreviewViewer>
    </div>



    <!-- CUSTOM TOGGLE -->
    <div class="mb-4 bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-4 pl-3 pr-3 mb-4">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Custom Toggle</h5>
        <p class="text-gray-500">Toggle with custom true and false values. Use the <span class="text-danger">true-value</span> and <span class="text-danger">false-value</span> props</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : viewCustom === 'preview'}" @click="viewCustom = 'preview'">Preview</b-button>
        <b-button :class="{'active' : viewCustom === 'code'}"  @click="viewCustom = 'code'">Code</b-button>
      </ButtonGroup>
    </div>
  
    <CodePreviewViewer :viewMode="viewCustom" :codeSample="require('@/components/local/Toggle/toggle_custom.js').default">
      <template v-slot:preview>
        <div class="bg-gray-100 p-3">
          <Toggle
            v-model="valueCustom"
            true-value="yes"
            false-value="no"
          />
    
          <div class="mt-2">Value: <strong>{{ valueCustom }}</strong></div>
        </div>
      </template>
    </CodePreviewViewer>
    </div>



    <!-- TOGGLE WITH LABELS -->
    <div class="mb-4 bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-4 pl-3 pr-3 mb-4">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Toggle with Labels</h5>
        <p class="text-gray-500">You can add labels beside the toggle by setting the <span class="text-danger">left-label</span> or <span class="text-danger">right-label</span> props</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : viewLabel === 'preview'}" @click="viewLabel = 'preview'">Preview</b-button>
        <b-button :class="{'active' : viewLabel === 'code'}"  @click="viewLabel = 'code'">Code</b-button>
      </ButtonGroup>
    </div>
  
    <CodePreviewViewer :viewMode="viewLabel" :codeSample="require('@/components/local/Toggle/toggle_label.js').default">
      <template v-slot:preview>
        <div class="bg-gray-100 p-3">
          <Toggle v-model="valueLabel" left-label="Left Label"/>
          <br><br>
          <Toggle v-model="valueLabelCustom" right-label="Right Label"/>
        </div>
      </template>
    </CodePreviewViewer>
    </div>



    <!-- SIZING -->
    <div class="mb-4 bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-4 pl-3 pr-3 mb-4">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Sizing</h5>
        <p class="text-gray-500">Use the <span class="text-danger">size</span> prop to control the size of the toggle</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : viewSizing === 'preview'}" @click="viewSizing = 'preview'">Preview</b-button>
        <b-button :class="{'active' : viewSizing === 'code'}"  @click="viewSizing = 'code'">Code</b-button>
      </ButtonGroup>
    </div>

    <CodePreviewViewer :viewMode="viewSizing" :codeSample="require('@/components/local/Toggle/toggle_sizing.js').default">
      <template v-slot:preview>
        <div class="bg-gray-100 p-3">
          <Toggle v-model="sizing" size="sm" right-label="Small"/>
          <br>
        
          <Toggle v-model="sizing" right-label="Medium"/>
          <br>
          
          <Toggle v-model="sizing" size="lg" right-label="Large"/>
        </div>
      </template>
    </CodePreviewViewer>
    </div>

  </div>
</template>


<script>
import Toggle from '@/components/export/Toggle/Toggle'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'

export default {
  components: { Toggle, ButtonGroup, CodePreviewViewer },

  data() {
    return { 
      view: 'preview',
      viewCustom: 'preview',
      viewLabel: 'preview',
      viewSizing: 'preview',
      value: false,  
      valueCustom: "no",
      valueLabel: false,  
      valueLabelCustom: "no",
      valueYes: true, 
      valueNo: false, 
      sizing: false   
    }
  },
}
</script>